export enum FormType {
    webExternal = 1,
    webInternal = 2,
    widgetAuthentication = 3,
    outlook = 4,
    survey = 5,

    inboxForwardForm = 100, // gui
    inboxSearch = 101, // gui
    inboxEditFields = 102, // gui

    widgetForm = 200, // gui
}
